module.exports = __webpack_public_path__ + "img/image.33f6b991.svg";